<app-report-html-page>
    <div class="border-top border-bottom bg-light px-2 py-2 mb-2 report-section-heading">
        <h4 class="h5 my-1">Peak exceedances</h4>
        <p class="mb-0 text-muted small">Highest contracted power and feed-in power exceedances per connection in the selected reporting period.</p>
    </div>
    <ng-container *ngIf="contractedPowerIncidentGroups.length; else noContractedPowerIncidents">
        <div class="border rounded mb-3" *ngFor="let group of contractedPowerIncidentGroups">
            <div class="bg-white border-bottom px-1 py-0">
                <h5 class="small mb-0 lh-sm notranslate">EAN {{ group.connectionCode }}</h5>
            </div>
            <ng-container *ngIf="group.consumptionRows.length">
                <div class="small fw-semibold text-muted px-1 py-1">Top 10 consumption exceedances</div>
                <table class="table table-sm table-striped mb-0 small lh-sm">
                    <thead class="table-light text-uppercase">
                    <tr>
                        <th class="py-1 px-1">#</th>
                        <th class="py-1 px-1">Moment</th>
                        <th class="py-1 px-1 text-end">Measured load</th>
                        <th class="py-1 px-1 text-end">Exceeded by</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let incident of group.consumptionRows; let index = index">
                        <td class="py-1 px-1 notranslate">{{ index + 1 }}</td>
                        <td class="py-1 px-1 notranslate">{{ incident.startLabel }}</td>
                        <td class="py-1 px-1 notranslate text-end">{{ incident.measuredValue | number:'1.0-2' }} {{ incident.unit }}</td>
                        <td class="py-1 px-1 notranslate text-end text-danger fw-semibold">{{ incident.exceedance | number:'1.0-2' }} {{ incident.unit }}</td>
                    </tr>
                    </tbody>
                </table>
            </ng-container>
            <ng-container *ngIf="group.feedInRows.length">
                <div class="small fw-semibold text-muted px-1 py-1">Top 5 feed-in exceedances</div>
                <table class="table table-sm table-striped mb-0 small lh-sm">
                    <thead class="table-light text-uppercase">
                    <tr>
                        <th class="py-1 px-1">#</th>
                        <th class="py-1 px-1">Moment</th>
                        <th class="py-1 px-1 text-end">Measured load</th>
                        <th class="py-1 px-1 text-end">Exceeded by</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let incident of group.feedInRows; let index = index">
                        <td class="py-1 px-1 notranslate">{{ index + 1 }}</td>
                        <td class="py-1 px-1 notranslate">{{ incident.startLabel }}</td>
                        <td class="py-1 px-1 notranslate text-end">{{ incident.measuredValue | number:'1.0-2' }} {{ incident.unit }}</td>
                        <td class="py-1 px-1 notranslate text-end text-danger fw-semibold">{{ incident.exceedance | number:'1.0-2' }} {{ incident.unit }}</td>
                    </tr>
                    </tbody>
                </table>
            </ng-container>
        </div>
    </ng-container>
    <ng-template #noContractedPowerIncidents>
        <div class="alert alert-light border text-center mb-0">
            No contracted power or feed-in power exceedances were found in this reporting period.
        </div>
    </ng-template>
</app-report-html-page>
